import { Dropdown, Icon, Input } from "@citi-icg-172888/icgds-react";
import { Size } from "@citi-icg-172888/icgds-react/Utils/util";
import _ from "lodash";
import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { useData } from "../services/context/DataContext";
import { detectZoom } from "../services/utils/utils";

interface IDropdownMultipleHocProps {
  name?: string;
  label?: string;
  options: string[];
  value: string[] | undefined;
  onChange: (options: string[]) => void;
  onApply?: (options: string[]) => void;
  className?: string;
  WrapperClassName?: string;
  size?: Size;
  style?: CSSProperties;
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  ariaLabelledBy?: string;
  isMultiple?: boolean;
  error?: string;
  menuClass?: string;
  menuStyle?: CSSProperties;
}

const DropdownMultipleHoc: React.FC<IDropdownMultipleHocProps> = ({
  name,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  label,
  options = [],
  onChange,
  onApply,
  size,
  style,
  WrapperClassName,
  placeholder,
  error,
  id,
  menuClass,
  menuStyle,
}) => {
  const { companyInfo } = useData();

  const [filterOptions, setFilterOptions] = useState([...options]);
  const searchRef = useRef(null);
  const [inputText, setInputText] = useState("");

  const onInputFocus = (e: { target: any }) => {
    if (inputText && inputText.length > 0) {
      const strLength = inputText.length;
      const input = e.target;
      if (input) {
        if (input.setSelectionRange !== undefined) {
          input.setSelectionRange(strLength, strLength);
        } else {
          input.value = inputText;
        }
      }
    }
  };

  const avoidTabToClose = (e: { key: string; stopPropagation: () => void }) => {
    // Tab
    if (e.key === "Tab") {
      e.stopPropagation();
    }
  };

  const focusSearch = (vis: any) => {
    setTimeout(() => {
      if (vis && searchRef.current) {
        (searchRef.current as HTMLInputElement).focus();
      }
    }, 200);
  };

  useEffect(() => {
    const zoom = detectZoom();
    console.log("Current Zoom Level:", zoom); // Log zoom level
  }, []);

  return (
    <div className={WrapperClassName} aria-describedby={id}>
      <Dropdown
        placeholder={placeholder || ""}
        multiple={true}
        name={name}
        value={companyInfo?.operatedCountry}
        aria-label={placeholder || ""}
        label={`Countries(${companyInfo?.operatedCountry?.length || 0})`}
        style={style}
        // aria-label={label}
        size={size}
        invalid={!!error}
        onClose={() => {
          setInputText("");
          setFilterOptions(options);
        }}
        onChange={(val: any) => onChange && onChange(val)}
        onApply={(val) => onApply && onApply(val)}
        onVisibleChange={focusSearch}
        dropdownRender={(optionsList, applyBtn) => {
          return (
            <>
              <div
                id="multipleDD"
                className="lmn-dropdown-header lmn-dropdown-header-search lmn-border-radius-none"
              >
                <div className="lmn-input-text lmn-search lmn-search-alt">
                  <Input
                    placeholder={placeholder || ""}
                    value={inputText}
                    ref={searchRef}
                    onFocus={onInputFocus}
                    onChange={(e) => {
                      const val = e.target.value;
                      setInputText(val);
                      setFilterOptions(
                        options.filter((i) =>
                          i.toLocaleLowerCase().includes(val.toLocaleLowerCase())
                        )
                      );
                    }}
                    onKeyDown={avoidTabToClose}
                  />
                  <Icon type="search" className="lmn-input-prefix-icon lmn-font-size-sm" />
                </div>
              </div>
              {optionsList}
              {applyBtn}
            </>
          );
        }}
        getPopupContainer={() => document.querySelector("#root")}
        menuAlignWidth
        menuStyle={menuStyle}
        menuClass={menuClass}
      >
        {filterOptions.length > 0 &&
          _.map(filterOptions, (option: string, index: number) => (
            <Dropdown.Item
              key={option}
              value={option}
              aria-label={option}
              aria-describedby={option}
              data-cv-tracking-id={`dropdown-item${index}-tracking-id`}
            >
              {option}
                          </Dropdown.Item>
          ))}
      </Dropdown>
    </div>
  );
};

export default DropdownMultipleHoc;
